import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PasswordResetSuccess() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="h-12 w-12 text-green-600" />
          </div>
          
          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Félicitations !
          </h1>
          
          {/* Description */}
          <p className="text-gray-600 mb-8 leading-relaxed">
            Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter à votre compte Cartopousse avec votre nouveau mot de passe.
          </p>
          
          {/* Success Features */}
          <div className="bg-green-50 rounded-lg p-4 mb-8">
            <div className="space-y-2 text-sm text-green-800">
              <div className="flex items-center">
                <CheckCircle className="h-4 w-4 mr-2 text-green-600" />
                <span>Mot de passe sécurisé</span>
              </div>
              <div className="flex items-center">
                <CheckCircle className="h-4 w-4 mr-2 text-green-600" />
                <span>Compte protégé</span>
              </div>
              <div className="flex items-center">
                <CheckCircle className="h-4 w-4 mr-2 text-green-600" />
                <span>Accès restauré</span>
              </div>
            </div>
          </div>
          
          {/* Action Button */}
          <Link
            to="/login"
            className="w-full inline-flex items-center justify-center px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-all duration-200 hover:shadow-lg font-medium"
          >
            Se connecter maintenant
            <ArrowRight className="h-5 w-5 ml-2" />
          </Link>
          
          {/* Security Tip */}
          <div className="mt-6 p-4 bg-blue-50 rounded-lg">
            <p className="text-xs text-blue-800">
              <strong>Conseil de sécurité :</strong> Gardez votre mot de passe confidentiel et ne le partagez jamais avec personne.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
